import {pageInfo, getExportData, upload, downLoadSoldToTemplate, detailInfo, editSubmit} from './../api';
import { Message } from 'element-ui';
const soldTo = {
  namespaced: true,
  state: {
    successCode:200,
    total:0,
    pageResp:null,
    exportObj: null,
    uploadObj: null,
    soldToTemplateObj: null,
    detailInfoObj: null,
    editSubmitObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      if (data.code === state.successCode){
        Message({showClose: true, message: data.msg, type: 'success'});
      }
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_SOLDTO(state, data) {
      state.uploadObj = data;
    },
    DOWN_LOAD_SOLD_TO_TEMPLATE(state, data) {
      state.soldToTemplateObj = data;
    },
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data;
    },
    EDIT_SUBMIT(state, data) {
      state.editSubmitObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async getExportData({commit}, obj){
      let resp = await getExportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //导入
    async upload({ commit }, obj) {
      let resp = await upload(obj);
      commit('UPLOAD_SOLDTO', resp);
    },
    //模板下载
    async downLoadSoldToTemplate({ commit }, obj) {
      let resp = await downLoadSoldToTemplate(obj);
      commit('DOWN_LOAD_SOLD_TO_TEMPLATE', resp);
    },
    //编辑详情
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    //编辑提交
    async editSubmit({ commit }, obj) {
      let resp = await editSubmit(obj);
      commit('EDIT_SUBMIT', resp);
    }
  }
}
export default soldTo



// WEBPACK FOOTER //
// ./src/page/md/soldTo/store/soldTo.store.js